import React from 'react';
import { observer } from 'mobx-react';
// import {toJS} from 'mobx';
import { VOTE_VIEW_SINGLE, PERM_VOTE_VIEW_OTHERS } from '../../../helpers/constants';

import VoteCard from './VoteCard';
import VoteResult from './VoteResult';

import store from '../../../stores/store';


const VoteDetails = observer(
    class VoteDetails extends React.Component {
        constructor(props) {
            super(props);

            this.toggle = this.toggle.bind(this);
            this.state = {
                activeTab: '1',
            };
        }

        toggle(tab) {
            if (this.state.activeTab !== tab) {
                this.setState({
                    activeTab: tab,
                });
            }
        }

        componentDidMount() {
            this.addListenerMulti();
        }

        componentWillUnmount() {
            this.removeListenerMulti();
        }

        canViewOtherVotes = vote => {
            return (vote.VotePermissions & PERM_VOTE_VIEW_OTHERS) === PERM_VOTE_VIEW_OTHERS;
        }

        /******************************************************************************
        captureAnimationEnd
        - IHT, Oct 17
        - need to listen for the end of the animations that open/close the Agenda page
        - open: only now can we resize the map correctly
        - close: only now can we redirect
        ******************************************************************************/
        captureAnimationEnd = () => {
            const domVote = document.getElementById('vote');
            store.companies.routeBeforeRefresh = '';

            if (domVote.classList.value.indexOf('zoomOut') !== -1) {
                this.props.history.push('/dashboard/votes');
            }
        };

        addListenerMulti() {
            const el = document.getElementById('vote');
            // const s = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";
            const s =
                'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            const fn = this.captureAnimationEnd;

            s.split(' ').forEach(e => {
                // console.log("addListenerMulti", e, el, fn);
                el.addEventListener(e, fn, false);
            });
        }

        removeListenerMulti() {
            const el = document.getElementById('vote');
            const s =
                'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            const fn = this.captureAnimationEnd;

            s.split(' ').forEach(e => {
                // console.log("removeListenerMulti", e, el, fn);
                el.removeEventListener(e, fn, false);
            });
        }

        /**
         * It closes modal window with group's agenda/governance
         * if groups's unselectedGroup is true, set to false
         */
        voteAnimations = () => {
            store.companies.routeBeforeRefresh = "";
            store.groups.resetVisualIndicatorsToSelectedGroup();
            this.props.history.push('/dashboard/votes');
        };

        displayMembers =(vote) => {
            const canViewOtherVotes = this.canViewOtherVotes(vote);
            if(canViewOtherVotes) {
                return (
                    <div>
                        <div className="line-break-border p-1"></div>
                        <div id="attendees-content" className="p-2 pt-3">
                            <VoteResult vote={vote} loadingGov={store.groups.loadingGov}/>
                        </div>
                    </div>
                );
            }
        }

        render() {
            const vote = store.votes.selectedVote !== null ? store.votes.selectedVote[0] : null;

            return (
                 <div className="card d-flex flex-column mb-3 animated zoomIn" id="vote">
                    <VoteCard
                        ref="VoteDetails"
                        viewType={VOTE_VIEW_SINGLE}
                        detail={vote}
                        instanceId={vote.InstanceId}
                        voteAnimations={this.voteAnimations}
                    />
                    {this.displayMembers(vote)}
                </div>
            );
        }
    },
);

export default VoteDetails;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Vote/VoteDetails.js